<template>
  <v-row
    v-if="resolved"
    class="d-flex"
  >
    <div class="org-detail-header">
      <div class="org-icon-outer d-flex">
        <div class="org-icon-inner">
          {{ orgInitial.toUpperCase() }}
        </div>
      </div>
      <div class="org-text-container">
        <div
          v-if="editing"
          class="org-edit-name my-2"
        >
          <v-form
            id="name-change"
            ref="form"
            v-model="valid"
          >
            <v-text-field
              v-model="newName"
              class="name-field mr-3"
              filled
              label="Organization Name"
              counter="50"
              :rules="rules"
              dense
            />

            <v-btn
              small
              color="secondary"
              class="org-edit-btn"
              @click="handleCancel"
            >
              <v-icon>
                $faTimes
              </v-icon>
            </v-btn>
            <v-btn
              small
              color="primary"
              class="org-edit-btn"
              :disabled="!valid"
              :loading="submitting"
              @click="handleSave"
            >
              <v-icon>
                $faCheck
              </v-icon>
            </v-btn>
          </v-form>
        </div>
        <h1
          v-else
          id="org-name"
        >
          {{ newName }}
          <v-btn
            v-if="canAdminOrg"
            fab
            text
            x-small
            @click="handleNameEdit"
          >
            <v-icon color="#929292">
              $faPencilAlt
            </v-icon>
          </v-btn>
        </h1>
        <div
          v-if="isInternal"
          class="d-flex sub-details"
          style="width:240px"
        >
          <span class="sub-details-item">ID: {{ subDetails.id }}</span>
          <span class="sub-details-item">Subscription Status: {{ subDetails.status | capitalizeStatus }}</span>
        </div>
      </div>
    </div>
  </v-row>
</template>
<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'OrgsDetailHeader',
    filters: {
      capitalizeStatus (val) {
        return val.charAt(0).toUpperCase() + val.slice(1)
      },
    },
    props: {
      orgDetails: {
        type: Object,
      },
      resolved: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        valid: true,
        editing: false,
        submitting: false,
        newName: '',
        details: null,
        rules: [
          value => value.length <= 50 || 'Max 50 characters',
          value => !!value || 'Required',
        ],
      }
    },
    computed: {
      orgInitial () {
        return this.orgDetails.name.slice(0, 1)
      },
      ...mapGetters({
        isInternal: 'Permissions/isInternal',
        canAdminOrg: 'Permissions/canAdminOrg',
      }),
      subDetails () {
        return { id: this.orgDetails.id, status: this.orgDetails.subscriptionStatus }
      },
    },
    watch: {
      orgDetails (newOrg) {
        if (newOrg) this.newName = newOrg.name
      },
    },
    created () {
      this.newName = this.orgDetails.name
    },
    methods: {
      handleNameEdit () {
        this.editing = true
      },
      handleCancel () {
        this.newName = this.orgDetails.name
        this.editing = false
      },
      async handleSave () {
        this.submitting = true
        const payload = {
          id: parseInt(this.subDetails.id),
          name: this.newName,
        }
        if (this.valid) {
          await this.$store.dispatch('Organizations/editOrgDetails', payload)
          this.editing = false
        }
        this.submitting = false
      },
    },
  }
</script>
<style lang="scss">
.org-icon-outer {
  border-radius: 50%;
  height:72px;
  width:72px;
  padding:2px;
  background-color: $muted;
  justify-content:center;
  align-items:center;
  .org-icon-inner {
    border-radius:50%;
    height:60px;
    width:60px;
    border: 3px solid white;
    color:white;
    display: flex;
    align-items: center;
    justify-content:center;
    font-size:39px;
    font-family: Lato, sans-serif;
    font-weight:600;
  }
}
.org-detail-header {
  display: flex;
  flex-direction: row;
  margin-left: 44px;
}
.org-text-container {
  margin-left: 20px;
  margin-top: 14px;
}

.org-edit-name {
  width:366px;
  #name-change {
    display:flex;
    justify-content: space-between;
    .name-field {
      max-width: 259px;
    }
    .org-edit-btn {
      height: 40px !important;
      width: 40px;
      min-width: 40px !important;
      max-width:40px;
    }
  }
}
h1#org-name {
  font-weight: 400;
  font-size: 36px;
  line-height: 40px;
  display: flex;
  align-items: center;
  letter-spacing: 1px;
}
.sub-details-item{
  color: #929292;
  white-space: nowrap;
  & + .sub-details-item {
    margin-left: 12px;
  }
}
</style>
